@if (elementContext?.viewType !== 'dialog' && elementContext?.viewType !== 'drawer') {
  <div class="flex gap-4 items-center" [ngStyle]="labelStyle()">
    @for (breadcrumb of drilldownPath(); track breadcrumb.label; let last = $last) {
      <div class="link-item" [class.active]="last" (click)="onOpenPath(breadcrumb, $event)"
        >{{ breadcrumb.label }}
      </div>
      @if (!last) {
        @switch (dividerType()) {
          @case ('arrow') {
            <mat-icon svgIcon="icon_arrow_16" [ngStyle]="dividerStyle()" />
          }
          @case ('dash') {
            <mat-icon svgIcon="icon_subtract_16" [ngStyle]="dividerStyle()" />
          }
          @case ('chevron') {
            <mat-icon svgIcon="icon_chevron_right_16" [ngStyle]="dividerStyle()" />
          }
          @default {
            <mat-icon svgIcon="icon_chevron_right_16" [ngStyle]="dividerStyle()" />
          }
        }
      }
    }
  </div>
} @else {
  @if (isInEditor) {
    <div class="notification">
      <div class="notification-content">
        Breadcrumbs are not available in dialog views and will not be displayed on the live page.
      </div>
    </div>
  }
}
